module.exports = __webpack_public_path__ + "img/pinterest.8da2c35f.svg";